import { useEffect } from "react";

const ColorInit = ({ color }) => {
  const host = new URL(window.location.href)?.host ?? "";

  useEffect(() => {
    if (host.startsWith("averon")) {
      document.documentElement.classList.add("averon-color");
    } else if (host.startsWith("makadarachem")) {
      document.documentElement.classList.add("makadara-color");
    } else {
      document.documentElement.classList.remove("color-two");
    }
    // if (color === true) {
    //   document.documentElement.classList.add("color-two");
    // } else {
    //   document.documentElement.classList.remove("color-two");
    // }
  }, [host]);
  return null;
};

export default ColorInit;
